import UbiServicesApi from "../api/UbiServicesApi";

export default class GamesPlayedService {
    static getGamesPlayed = async (ticket: string, sessionId: string) => {
        return UbiServicesApi.get(
            `/v1/profiles/me/gamesplayed`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID,
                    'Authorization': `ubi_v1 t=${ticket}`,
                    'Ubi-SessionId': sessionId,
                }
            }
        );
    };
}